import { useQuery } from 'react-query';
import { api } from '#/apis';

const getReportsCompactCache = async () => {

    const { data } = await api.get('/reports-compact-cache');

    return data;
};

export const useReportsCompactCache = (queryOptions = {}) => useQuery('reports-compact-cache-get', () => getReportsCompactCache(queryOptions));
